import { createTariffPlanType, updateTariffPlanTypes, } from "@Api/CountrySettings/countryGroup";
import Button from "@Components/Button";
import Card from "@Components/Card";
import Close from "@Components/Icons/Close";
import Loading from "@Components/Icons/Loading";
import InfoPopup from "@Components/InfoPopup";
import { ERROR, SUCCESS } from "@Components/Toast";
import Box from "@mui/material/Box";
import React from "react";
import styles from "./index.module.scss";
export default class Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.plan?.name || "",
            errors: {},
            isDirtyForm: false,
            isLoading: false,
        };
    }
    componentDidUpdate(previousProps) {
        if (this.props.plan?.id !== previousProps.plan?.id) {
            this.setState({
                name: this.props.plan?.name || "",
                errors: {},
                isDirtyForm: false,
            });
        }
        if (!this.props.open && previousProps.open) {
            this.setState({
                name: this.props.plan?.name || "",
                errors: {},
                isDirtyForm: false,
            });
        }
    }
    update = async () => {
        this.setState({ isLoading: true });
        try {
            const data = {
                id: this.props.plan.id,
                name: this.state.name,
            };
            await updateTariffPlanTypes(data);
            this.props.close(true);
            this.props.notify({
                status: SUCCESS,
                title: "Success",
                description: "Tariff plan type name updated successfully.",
            });
        }
        catch (error) {
            const errorResponse = error.response;
            if (errorResponse?.status === 405) {
                this.props.notify({
                    status: ERROR,
                    title: "Error",
                    description: errorResponse.data?.message,
                });
                return;
            }
            console.log("error", error);
            this.props.notify({
                status: ERROR,
                title: "Error",
                description: "Failed to update Tariff plan type name.",
            });
        }
        finally {
            this.setState({ isLoading: false });
        }
    };
    create = async () => {
        this.setState({ isLoading: true });
        try {
            await createTariffPlanType({
                name: this.state.name,
            });
            this.props.close(true);
            this.props.notify({
                status: SUCCESS,
                title: "Success",
                description: "Tariff plan type created successfully.",
            });
        }
        catch (error) {
            const errorResponse = error.response;
            if (errorResponse?.status === 405) {
                this.props.notify({
                    status: ERROR,
                    title: "Error",
                    description: errorResponse.data?.message,
                });
                return;
            }
            console.log("error", error);
            this.props.notify({
                status: ERROR,
                title: "Error",
                description: "Failed to create tariff plan type.",
            });
        }
        finally {
            this.setState({ isLoading: false });
        }
    };
    onSave = () => {
        if (!this.state.isDirtyForm || this.state.isLoading) {
            return;
        }
        if (this.props.plan?.id) {
            return this.update();
        }
        return this.create();
    };
    validatePlanName = (value) => {
        if (value.trim() === "") {
            return "Tariff plan type name can not be empty.";
        }
        if (value.length > 250) {
            return "Input exceeds 250 character limit.";
        }
        return "";
    };
    change = (name, value) => {
        this.setState((previousState) => ({
            ...previousState,
            errors: {
                name: this.validatePlanName(value),
            },
            [name]: value,
            isDirtyForm: true,
        }));
    };
    createPopup = (close) => {
        return (React.createElement(Card, { className: styles.container },
            React.createElement(Box, { className: styles.header },
                React.createElement("h2", { className: styles.title }, this.props.plan?.name
                    ? "Edit tariff plan type"
                    : "New tariff plan type"),
                React.createElement("div", { onClick: () => close(), className: styles.closeBtn },
                    React.createElement(Close, { onClick: () => close(), color: "#585C61", size: "0.75rem", className: styles.exitButton }))),
            React.createElement(Box, { className: styles.content },
                React.createElement("div", { className: styles.inputForm },
                    React.createElement("label", null,
                        "Tariff plan type name ",
                        React.createElement("span", null, "*")),
                    React.createElement("input", { key: this.props.plan?.id || "new", defaultValue: this.props.plan?.name || "", placeholder: "Enter tariff plan name", name: "name", type: "text", onChange: (event) => this.change("name", event.target.value) }),
                    this.state.errors.name && (React.createElement("div", { className: styles.error }, this.state.errors.name)))),
            React.createElement(Box, { className: styles.actions },
                React.createElement(Button, { click: () => close(), dark: true, className: styles.cancelBtn }, "CANCEL"),
                React.createElement(Button, { className: `${this.state.isDirtyForm && !this.state.errors.name
                        ? ""
                        : styles.disabled}`, click: this.onSave, disabled: !this.state.isDirtyForm ||
                        !!this.state.errors.name ||
                        this.state.isLoading }, this.state.isLoading ? (React.createElement(Loading, { size: "1rem" })) : ("SAVE")))));
    };
    render() {
        return (React.createElement(InfoPopup, { trigger: this.props.open, content: this.createPopup, onClose: () => this.props.close() }));
    }
}
